const faqItems = [
  {
    id: 1,
    q: '番茄视频是否需要注册才能观看？',
    a: '不需要。番茄视频所有影视资源均支持免费在线观看，无需注册登录即可直接播放香蕉视频、红桃视频、蜜桃视频等全部内容，真正做到即点即看。',
  },
  {
    id: 2,
    q: '播放画质可以达到什么水平？',
    a: '番茄视频支持最高1080P全高清画质播放，采用先进视频编码技术和CDN加速分发，确保在各类网络环境下都能获得清晰流畅的观影体验。部分热门影片更提供超清画质选项。',
  },
  {
    id: 3,
    q: '是否支持手机和平板观看？',
    a: '完全支持。番茄视频采用响应式设计，自动适配手机、平板、电脑等多种设备屏幕。您也可以通过下载番茄视频APP获得更佳的移动观影体验，支持离线缓存功能。',
  },
  {
    id: 4,
    q: '影片更新频率如何？',
    a: '番茄视频每日更新最新影视资源，热门剧集和综艺通常在播出后24小时内同步上线。香蕉视频、红桃视频、蜜桃视频和91视频四大频道各有侧重，确保您不错过任何精彩内容。',
  },
  {
    id: 5,
    q: '播放时出现缓冲怎么办？',
    a: '番茄视频采用多节点CDN加速，正常情况下播放流畅不缓冲。如果遇到卡顿，建议检查网络连接或尝试切换画质。我们的技术团队持续优化播放体验，确保高清不缓冲的承诺。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">常见问题</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">关于番茄视频，您可能想了解的问题都在这里</p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item) => (
            <div key={item.id} className="bg-background-100 rounded-xl border border-background-200/60 overflow-hidden">
              <div className="p-5 md:p-6">
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-xs font-bold text-primary-600">Q</span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-base font-semibold text-foreground-950 mb-2">{item.q}</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}